const accordion = () => {
    document.addEventListener('DOMContentLoaded', function () {
        // Check if there are any accordion items, if not, exit.
        let accordionItems = document.querySelectorAll('.accordion__item');
        if (!accordionItems) return;

        // Add a click event listener for each item
        accordionItems.forEach(function(item) {
            item.querySelector('.accordion__item--title').addEventListener('click', function() {
                // Get the content of the current item
                let content = item.querySelector('.accordion__item--hidden');

                // If the content is already expanded, collapse it.
                if(content.classList.contains('accordion__item--hidden-open')) {
                    content.classList.remove('accordion__item--hidden-open');
                    item.classList.remove('accordion__item--open'); // Remove class from the parent
                } else {
                    // Otherwise, expand the current content and close other items.
                    content.classList.add('accordion__item--hidden-open');
                    item.classList.add('accordion__item--open'); // Add class to the parent

                    // Close other accordion items
                    accordionItems.forEach(function(innerItem) {
                        if(innerItem !== item) {
                            let innerContent = innerItem.querySelector('.accordion__item--hidden');
                            innerContent.classList.remove('accordion__item--hidden-open');
                            innerItem.classList.remove('accordion__item--open'); // Remove class from other parents
                        }
                    });
                }
            });
        });
    });
}

accordion();